var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3228 7.7165C24.0569 7.47587 23.7075 7.34866 23.3491 7.36201C22.9907 7.37535 22.6517 7.52818 22.4044 7.78792C22.1571 8.04765 22.0211 8.39372 22.0253 8.75233C22.0296 9.11094 22.1738 9.4537 22.4271 9.7075L33.8873 20.6232H6.87496C6.51029 20.6232 6.16055 20.768 5.90269 21.0259C5.64482 21.2838 5.49996 21.6335 5.49996 21.9982C5.49996 22.3628 5.64482 22.7126 5.90269 22.9704C6.16055 23.2283 6.51029 23.3732 6.87496 23.3732L33.8873 23.3732L22.4271 34.2907C22.2963 34.4151 22.1912 34.5642 22.118 34.7292C22.0447 34.8943 22.0047 35.0722 22.0002 35.2527C21.9957 35.4333 22.0267 35.6129 22.0917 35.7815C22.1566 35.95 22.2541 36.1041 22.3785 36.2349C22.503 36.3658 22.652 36.4708 22.8171 36.5441C22.9822 36.6173 23.1601 36.6574 23.3406 36.6619C23.5211 36.6664 23.7008 36.6353 23.8693 36.5704C24.0379 36.5055 24.1919 36.408 24.3228 36.2835L37.9261 23.3273C38.2233 23.0444 38.4169 22.67 38.4761 22.264C38.5079 22.0881 38.5073 21.908 38.4743 21.7323C38.4143 21.3276 38.2207 20.9546 37.9243 20.6727L24.3228 7.7165Z",
    fill: "#7280FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.5450c8535682cdd5e71862aa31832eab.svg";
export { ForwardRef as ReactComponent };